import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import API from "../../../../api/axios";
import { APP_URLS } from "../../../../api/url";
import moment from "moment-timezone";
import NoRecord from "../../../../assets/SharedComponents/Table/NoRecord";
import { NavLink } from "react-router-dom";

const budgetRangeTextMap = {
  1: "Less than 10 000 €",
  2: "10 000 € - 20 000 €",
  3: "20 000 € - 40 000 €",
  4: "40 000 € and more",
};

const Leads = ({ userId }) => {
  const [consents, setConsents] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!userId) return;
    fetchLeads();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const fetchLeads = () => {
    setLoading(true);
    API.get(`${APP_URLS.USER_LEADS}/${userId}/leads`)
      .then((res) => {
        const resp = res.data;
        setLoading(false);
        if (resp.success === true && resp.data && resp.data.items) {
          setConsents(resp.data.items || []);
        } else {
          toast.error(resp.message, {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        const resp = error.response || {};
        let error_message = "";

        if (resp.data && resp.data.data !== undefined && resp.data.data !== null) {
          Object.keys(resp.data.data).forEach((key) => {
            error_message = resp.data.data[key][0];
          });
        } else if (resp.data && resp.data.error !== undefined) {
          error_message = resp.data.error;
        } else if (resp.data && resp.data.message !== undefined) {
          error_message = resp.data.message;
        } else {
          error_message = "Something went wrong while fetching leads.";
        }

        toast.error(error_message, {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const renderBody = () => {
    if (loading) {
      return (
        <tr>
          <td colSpan={6} style={{ textAlign: "center" }}>
            Loading...
          </td>
        </tr>
      );
    }

    if (!consents.length) {
      return (
        <tr>
          <td colSpan={6}>
            <NoRecord />
          </td>
        </tr>
      );
    }

    return consents.map((consent) => (
      <tr
        className={(consent.deleted_at ? "deletedRow " : "") + "table-row"}
        key={consent.id}
      >
        <td>{consent.vertical?.label || "-"}</td>
        <td>{consent.partner_snapshot_id || "-"}</td>
        <td>
          {consent.privacy_policy_version_id ?
            <NavLink to={`/legal-documents/preview/${consent.privacy_policy_version_id}`} target="_blank" className='link'>
              {consent.privacy_policy_version_id}
            </NavLink>
          : (
            "-"
          )}
        </td>
        <td>{consent.source_identifier || "-"}</td>
        <td>{budgetRangeTextMap[consent.budget_range] || "-"}</td>
        <td>
          {consent.created_at
            ? moment(consent.created_at)
                .tz("Europe/Amsterdam")
                .format("DD-MM-YYYY HH:mm")
            : "-"}
        </td>
      </tr>
    ));
  };

  return (
    <div className="tableContainer">
      <table className="auctionTable">
        <thead className="tableHead">
          <tr className="table-row">
            <th>VERTICAL</th>
            <th>PARTNER SNAPSHOT ID</th>
            <th>PRIVACY POLICY VERSION ID</th>
            <th>SOURCE IDENTIFIER</th>
            <th>BUDGET RANGE</th>
            <th>CREATED AT</th>
          </tr>
        </thead>
        <tbody>{renderBody()}</tbody>
      </table>
    </div>
  );
};

export default Leads;

